import { configureStore } from "@reduxjs/toolkit";
import themeReducer from "./reducers/toggle/themeToggle";
import modeReducer from "./reducers/toggle/modeToggle";
import langReducer from "./reducers/toggle/langToggle";
import saviorsReducer from "./reducers/list/saviorList";
import arcanasReducer from "./reducers/list/arcanaList";
import journeysReducer from "./reducers/list/journeyList";
import decksReducer from "./reducers/list/deckList";
import gachaReducer from "./reducers/list/gachaList";
import scheduleReducer from "./reducers/list/scheduleList";
import itemReducer from "./reducers/list/itemList";
import battleContentsReducer from "./reducers/list/battleContentList";
import potentialsReducer from "./reducers/list/potentialList";
import fullScreenReducer from "./reducers/toggle/fullScreenArcpintToggle";
import scheduleModalToggleReducer from "./reducers/toggle/scheduleModalToggle";

export default configureStore({
    reducer: {
        theme: themeReducer,
        lang: langReducer,
        mode: modeReducer,

        saviors: saviorsReducer,
        arcanas: arcanasReducer,
        journeys: journeysReducer,
        decks: decksReducer,
        gacha: gachaReducer,
        schedules: scheduleReducer,
        items: itemReducer,
        battleContents: battleContentsReducer,
        potentials: potentialsReducer,

        scheduleModal: scheduleModalToggleReducer,
        fullscreen: fullScreenReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false,
        }),
});
